var _desc, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSysarLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 3.6.3")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.494563179602549 0 0 3.494563179602549 249.99999999999997 250)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -52.10000000000001 -52.05000000000001)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(246,88,67)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -14.05,
    y: -14.05,
    rx: 0,
    ry: 0,
    width: 28.1,
    height: 28.1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 55 23.450000000000003)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(247,209,30)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -12.25,
    y: -12.25,
    rx: 0,
    ry: 0,
    width: 24.5,
    height: 24.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 33.2 -16.549999999999994)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(63,181,191)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -9.45,
    y: -13.05,
    rx: 0,
    ry: 0,
    width: 18.9,
    height: 26.1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 58.1 58.45000000000001)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(246,88,67)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -8.85,
    y: -8.85,
    rx: 0,
    ry: 0,
    width: 17.7,
    height: 17.7
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -50.800000000000004 -3.450000000000003)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(247,209,30)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -15.35,
    y: -19.85,
    rx: 0,
    ry: 0,
    width: 30.7,
    height: 39.7
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -5.050000000000004 8.799999999999997)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(246,88,67)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -15.9,
    y: -22.4,
    rx: 0,
    ry: 0,
    width: 31.8,
    height: 44.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 54.85 -54.00000000000001)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(246,88,67)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -12.1,
    y: -12.1,
    rx: 0,
    ry: 0,
    width: 24.2,
    height: 24.2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -12.850000000000009 58.45000000000001)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(247,209,30)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -20,
    y: -8.85,
    rx: 0,
    ry: 0,
    width: 40,
    height: 17.7
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 3.0499999999999936 -54)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(247,209,30)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -12.2,
    y: -12.2,
    rx: 0,
    ry: 0,
    width: 24.4,
    height: 24.4
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -59.150000000000006 53.79999999999999)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(63,181,191)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -7,
    y: -13.4,
    rx: 0,
    ry: 0,
    width: 14,
    height: 26.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 63.400000000000006 -13.850000000000003)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(247,209,30)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -3.55,
    y: -7.35,
    rx: 0,
    ry: 0,
    width: 7.1,
    height: 14.7
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 26.39999999999999 61.95)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(63,181,191)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -5.25,
    y: -5.25,
    rx: 0,
    ry: 0,
    width: 10.5,
    height: 10.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSysarLogo);
export default __webpack_public_path__ + "static/media/sysar-logo.6d3016b55257a5b566e36a2a47bf79a5.svg";
export { ForwardRef as ReactComponent };